import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Checkbox,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Snackbar,
  Alert,
  Chip,
  Grid,
  IconButton,
  Avatar,
} from "@mui/material";
import { db } from "../../../firebase"; // Adjust the path to your Firebase config
import {
  addDoc,
  collection,
  updateDoc,
  serverTimestamp,
  getDoc,
  doc,
} from "firebase/firestore";
import { useLocation, useNavigate } from "react-router-dom"; // Import useNavigate

import PhotoCamera from "@mui/icons-material/PhotoCamera";
import DynamicUploadModal from "../../../components/UploadModal";
import {
  insertEntity,
  updateEntity,
} from "../../../components/supabae/SupabaseSearchEntity"; // Import the script
import SpecialitiesSelector from "../../../components/topicCategorySelector/SpecialitiesSelector";
import ClinicSelector from "../../../components/topicCategorySelector/ClinicSelector";
import SymptomSelector from "../../../components/topicCategorySelector/SymptomSelector";

const AddDoctor = () => {
  const [openModal, setOpenModal] = useState(false);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(""); // State to store the uploaded URL
  const [doctorData, setDoctorData] = useState({
    doctorName: "",
    email: "",
    phone: "",
    altphone: "",
    address: "",
    pincode: "",
    district: "",
    state: "",
    country: "",
    specialist: "",
    symptoms: [], // Array of symptom objects
    symptom_ids: [], // Array of symptom IDs
    qualification: "MBBS,MD",
    regNo: "",
    experience: "",
    fees: "",
    discountfees: "",
    geohash: "",
    imgurl: "",
    gender: "",
    category: "",
    clinicname: "",
    clinic_id: "",
    user_id: "",
    lat: "",
    lng: "",
    description: "",
    status: "Active",
    is_online: true,
    rating: 0,
    verifyPercentage: "80",
    language: {
      English: { enable: true, value: "English" },
      Hindi: { enable: true, value: "Hindi" },
      Bengali: { enable: false, value: "Bengali" },
      Telugu: { enable: false, value: "Telugu" },
      Marathi: { enable: false, value: "Marathi" },
      Tamil: { enable: false, value: "Tamil" },
      Gujarati: { enable: false, value: "Gujarati" },
      Urdu: { enable: false, value: "Urdu" },
      Assamese: { enable: false, value: "Assamese" },
      Punjabi: { enable: false, value: "Punjabi" },
      Malayalam: { enable: false, value: "Malayalam" },
    },
    open_date_time: {
      Monday: { open: true, firstHalf: "", secondHalf: "" },
      Tuesday: { open: true, firstHalf: "", secondHalf: "" },
      Wednesday: { open: true, firstHalf: "", secondHalf: "" },
      Thursday: { open: true, firstHalf: "", secondHalf: "" },
      Friday: { open: true, firstHalf: "", secondHalf: "" },
      Saturday: { open: true, firstHalf: "", secondHalf: "" },
      Sunday: { open: false, firstHalf: "", secondHalf: "" },
    },
  });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [loading, setLoading] = useState(true);

  // Function to parse query parameters
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const navigate = useNavigate(); // Initialize navigate
  const query = useQuery();
  const uid = query.get("uid"); // Extracting uid from query parameters

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, "doctors", uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setDoctorData(docSnap.data());
        } else {
          console.log("No document found");
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      } finally {
        setLoading(false);
      }
    };
    if (uid) fetchData();
  }, [uid]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDoctorData((prevData) => ({
      ...prevData,
      [name]: value,
      timestamp: serverTimestamp(),
    }));
  };

  // Handle category selection from the CategorySelector

  const handleSelectSpecialities = (selectedSpeciality) => {
    setDoctorData((prevData) => ({
      ...prevData,
      specialist: selectedSpeciality.name, // Update the specialist field
      specialist_id: selectedSpeciality.id, // Update the specialist field
    }));
  };

  // Handle multiple symptom selection
  const handleSelectSymptom = (selectedSymptom) => {
    setDoctorData((prevData) => {
      const existingIds = prevData.symptom_ids; // Get existing IDs

      if (!existingIds.includes(selectedSymptom.id)) {
        return {
          ...prevData,
          symptoms: [...prevData.symptoms, selectedSymptom], // Add full symptom object
          symptom_ids: [...prevData.symptom_ids, selectedSymptom.id], // Add symptom ID
        };
      }

      return prevData; // No changes if already selected
    });
  };

  // Handle removing a symptom
  const handleRemoveSymptom = (id) => {
    setDoctorData((prevData) => ({
      ...prevData,
      symptoms: prevData.symptoms.filter((symptom) => symptom.id !== id), // Remove full object
      symptom_ids: prevData.symptom_ids.filter((symptomId) => symptomId !== id), // Remove ID
    }));
  };

  const handleSelectClinic = (selectedClinic) => {
    setDoctorData((prevData) => ({
      ...prevData,
      clinicname: selectedClinic.name, // Update the specialist field
      clinic_id: selectedClinic.id, // Update the specialist field
    }));
  };

  const handleLanguageChange = (lang) => {
    setDoctorData((prevData) => ({
      ...prevData,
      language: {
        ...prevData.language,
        [lang]: {
          ...prevData.language[lang],
          enable: !prevData.language[lang].enable,
        },
      },
    }));
  };

  const handleOpenDateTimeChange = (day, field, value) => {
    setDoctorData((prevData) => ({
      ...prevData,
      open_date_time: {
        ...prevData.open_date_time,
        [day]: { ...prevData.open_date_time[day], [field]: value },
      },
    }));
  };

  const handleAddOrUpdateDoctor = async () => {
    if (!doctorData.doctorName || !doctorData.email || !doctorData.phone) {
      setSnackbarMessage("Please fill in all required fields.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
  
    try {
      if (uid) {
        const docRef = doc(db, "doctors", uid);
        await updateDoc(docRef, doctorData);
  
        const entityData = {
          name: doctorData.doctorName,
          id: docRef.id,
          entityType: "doctor",
          entityId: docRef.id,
          title: doctorData.doctorName,
          subtitle: `${doctorData.doctorName} (${doctorData.specialist})`,
          description: doctorData.description,
          tags: "doctor",
          route: "/doctor",
          country: doctorData.country,
          state: doctorData.state,
          district: doctorData.district,
          city: doctorData.city || "",
          pincode: doctorData.pincode,
          latitude: doctorData.lat,
          longitude: doctorData.lng,
        };
  
        await updateEntity(docRef.id, entityData);
        setSnackbarMessage("Doctor data updated successfully!");
        setSnackbarSeverity("success");
      } else {
        const docRef = await addDoc(collection(db, "doctors"), doctorData);
  
        const entityData = {
          name: doctorData.doctorName,
          id: docRef.id,
          entityType: "doctor",
          entityId: docRef.id,
          title: doctorData.doctorName,
          subtitle: `${doctorData.doctorName} (${doctorData.specialist})`,
          description: doctorData.description,
          tags: "doctor",
          route: "/doctor",
          country: doctorData.country,
          state: doctorData.state,
          district: doctorData.district,
          city: doctorData.city || "",
          pincode: doctorData.pincode,
          latitude: doctorData.lat,
          longitude: doctorData.lng,
        };
  
        await insertEntity(entityData);
        await updateDoc(docRef, { user_id: docRef.id });
  
        setSnackbarMessage("Doctor added successfully!");
        setSnackbarSeverity("success");
      }
    } catch (error) {
      console.error("Error processing doctor data:", error);
      setSnackbarMessage(
        uid
          ? "Failed to update doctor data. Please try again."
          : "Failed to add doctor. Please try again."
      );
      setSnackbarSeverity("error");
    } finally {
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleUploadSuccess = (url) => {
    console.log("Image uploaded successfully! URL:", url);
    setUploadedImageUrl(url); // Set the uploaded URL to the state
    setDoctorData((prevData) => ({
      ...prevData,
      imgurl: url, // Set the uploaded URL in the doctorData
    }));
    handleModalClose(); // Close the modal after successful upload
  };

  const handleModalClose = () => {
    setOpenModal(false);
  };

  // Function to navigate to the timetable page
  const handleAddTimetable = () => {
    navigate(`/timetable?uid=${uid}`); // Redirect to the timetable page with uid
  };
  return (
    <Box sx={{ padding: 2, width: "60%", margin: "auto" }}>
      <Avatar
        style={{
          width: 100,
          height: 100,
          margin: "0 auto",
          marginBottom: 20,
        }}
      >
        {doctorData.imgurl ? (
          <img
            src={doctorData.imgurl}
            alt="Category"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "50%",
            }}
          />
        ) : (
          <PhotoCamera style={{ fontSize: 50, color: "#2058C8FF" }} />
        )}
      </Avatar>
         
      <Box
      sx={{
        display: 'flex',
        justifyContent: 'center', 
        alignItems: 'center', 
        width: '100%',
       
      }}
    >
      <Button variant="outlined" color="secondary" onClick={handleAddTimetable}>
        Add Timetable
      </Button>
    </Box>
      <Typography sx={{ fontSize: 16, color: "#326377FF" }}>
        {uid ? "Update Doctor" : "Add New Doctor"}
      </Typography>
      <Box sx={{ height: "20px" }}></Box>

      {/* Input Fields */}
      <TextField
        label="Doctor Name"
        name="doctorName"
        value={doctorData.doctorName}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      <TextField
        label="Email"
        name="email"
        type="email"
        value={doctorData.email}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      <TextField
        label="Phone"
        name="phone"
        value={doctorData.phone}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      <TextField
        label="Alternate Phone"
        name="altphone"
        value={doctorData.altphone}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      <TextField
        label="Address"
        name="address"
        value={doctorData.address}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      <TextField
        label="Pincode"
        name="pincode"
        value={doctorData.pincode}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      <TextField
        label="District"
        name="district"
        value={doctorData.district}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      <TextField
        label="State"
        name="state"
        value="West Bengal"
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      <TextField
        label="Country"
        name="country"
        value="India"
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />

      <SymptomSelector onSelectSymptom={handleSelectSymptom} />

      <Typography variant="subtitle1" sx={{ marginTop: 2 }}>
        Selected Symptoms:
      </Typography>
      <Grid container spacing={1}>
        {doctorData.symptoms.map((symptom) => (
          <Grid item key={symptom.id}>
            <Chip
              label={symptom.name}
              onDelete={() => handleRemoveSymptom(symptom.id)}
              color="primary"
            />
          </Grid>
        ))}
      </Grid>

      <Box>
        <SpecialitiesSelector onSelectSpecialities={handleSelectSpecialities} />
        <Box sx={{ height: 16 }} /> {/* Adds a gap of 16px */}
        <TextField
          label="Specialist"
          name="specialist"
          value={doctorData.specialist}
          InputProps={{ readOnly: true }}
          onChange={handleInputChange}
          fullWidth
          sx={{ marginBottom: 2 }}
        />
      </Box>

      <TextField
        label="Qualification"
        name="qualification"
        value={doctorData.qualification}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      <TextField
        label="Registration Number"
        name="regNo"
        value={doctorData.regNo}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      <TextField
        label="Experience (years)"
        name="experience"
        type="number"
        value={doctorData.experience}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      <TextField
        label="Fees"
        name="fees"
        type="number"
        value={doctorData.fees}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      <TextField
        label="Discount Fees"
        name="discountfees"
        type="number"
        value={doctorData.discountfees}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      {/* <TextField
        label="Geohash"
        name="geohash"
        value={doctorData.geohash}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      /> */}

      {/* Image Upload Field */}
      <TextField
        fullWidth
        label="Image URL"
        name="imgurl"
        value={doctorData.imgurl}
        onChange={handleInputChange}
      />

      <Grid item xs={12}>
        <IconButton
          onClick={() => setOpenModal(true)}
          color="primary"
          aria-label="upload image"
        >
          <PhotoCamera />
        </IconButton>
      </Grid>

      {/* Gender Select */}
      <FormControl fullWidth sx={{ marginBottom: 2 }}>
        <InputLabel>Gender</InputLabel>
        <Select
          name="gender"
          value={doctorData.gender}
          onChange={handleInputChange}
        >
          <MenuItem value="Male">Male</MenuItem>
          <MenuItem value="Female">Female</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </Select>
      </FormControl>

      {/* <TextField
        label="Category"
        name="category"
        value={doctorData.category}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      /> */}
      <Box>
        <ClinicSelector onSelectClinic={handleSelectClinic} />
        <Box sx={{ height: 16 }} /> {/* Adds a gap of 16px */}
      </Box>
      <TextField
        label="Clinic Name"
        name="clinicname"
        value={doctorData.clinicname}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      <TextField
        label="Clinic ID"
        name="clinic_id"
        value={doctorData.clinic_id}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />

      {/* <TextField
        label="Latitude"
        name="lat"
        value={doctorData.lat}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      />
      <TextField
        label="Longitude"
        name="lng"
        value={doctorData.lng}
        onChange={handleInputChange}
        fullWidth
        sx={{ marginBottom: 2 }}
      /> */}
      <TextField
        label="Description"
        name="description"
        value={doctorData.description}
        onChange={handleInputChange}
        fullWidth
        multiline
        rows={4}
        sx={{ marginBottom: 2 }}
      />
      {/* Language Preferences */}
      <Typography variant="h6" sx={{ marginBottom: 1 }}>
        Languages:
      </Typography>
      {Object.keys(doctorData.language).map((lang) => (
        <Chip
          key={lang}
          label={doctorData.language[lang].value}
          onClick={() => handleLanguageChange(lang)}
          color={doctorData.language[lang].enable ? "primary" : "default"}
          sx={{ marginRight: 1, marginBottom: 1 }}
        />
      ))}
      {/* Operating Hours Section */}
      <Typography variant="h5" sx={{ marginTop: 3 }}>
        Operating Hours
      </Typography>
      <Grid container spacing={2}>
        {Object.entries(doctorData.open_date_time).map(([day, timings]) => (
          <Grid item xs={12} sm={6} md={4} key={day}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Typography variant="h6">{day}</Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <TextField
                  fullWidth
                  type="time"
                  label="First Half"
                  value={timings.firstHalf}
                  onChange={(e) =>
                    handleOpenDateTimeChange(day, "firstHalf", e.target.value)
                  }
                />
                <Checkbox
                  checked={timings.open}
                  onChange={() =>
                    handleOpenDateTimeChange(day, "open", !timings.open)
                  }
                  inputProps={{ "aria-label": `${day} open checkbox` }}
                />
              </Box>
              <TextField
                fullWidth
                type="time"
                label="Second Half"
                value={timings.secondHalf}
                onChange={(e) =>
                  handleOpenDateTimeChange(day, "secondHalf", e.target.value)
                }
              />
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Add Doctor Button */}
      <Button
        variant="contained"
        onClick={handleAddOrUpdateDoctor}
        color="primary"
      >
        {uid ? "Update Doctor" : " Add Doctor"}
      </Button>

      {/* Snackbar for feedback */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Upload Modal */}
      <DynamicUploadModal
        open={openModal}
        onClose={handleModalClose}
        uploadPreset="bookMyDr" // Custom Cloudinary upload preset
        folderName="Madecare" // Custom folder name
        maxSize={5 * 1024 * 1024} // Custom max file size: 5MB
        onUploadSuccess={handleUploadSuccess} // Callback after success
      />
    </Box>
  );
};

export default AddDoctor;
